import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import IconTwilio from "../../iconComponents/IconTwilio";
import { Box, IconButton } from "@mui/material";

export const SocialButtons = () => {
  const listSocialMedia = [
    {
      label: "Instagram",
      Icon: InstagramIcon,
      link: "https://www.instagram.com/governo_Es/",
    },
    {
      label: "Facebook",
      Icon: FacebookRoundedIcon,
      link: "https://www.facebook.com/GovernoES",
    },
    {
      label: "Twitter",
      Icon: TwitterIcon,
      link: "https://twitter.com/governoes",
    },
    {
      label: "YouTube",
      Icon: YouTubeIcon,
      link: "https://www.youtube.com/user/governoes",
    },
    {
      label: "Flickr",
      Icon: IconTwilio,
      link: "https://www.flickr.com/photos/governodoes/albums/",
    },
  ];

  const styleIcons = {
    iconButtons: {
      width: 32,
      height: 32,
      backgroundColor: "#999EB0",
      "@media (max-width: 800px)": {
        backgroundColor: "#fff",
      },
      svg: {
        color: "#001737",
      },
      "&:hover": {
        backgroundColor: "#fff",
      },
      borderRadius: "50%",
    },
    icons: {
      width: 18,
      height: 18,
    },
    box: {
      display: "flex",
      justifyContent: "space-between",
      gap: 1,
      padding: 0,
      minHeight: "auto",
      "& svg": {
        color: "#FDFDFD",
      },
    },
  };

  return (
    <Box sx={styleIcons.box}>
      {listSocialMedia.map(({ label, link, Icon }, index) => (
        <IconButton
          color="inherit"
          key={index}
          component="a"
          href={link}
          target="_blank"
          rel={label}
          aria-label={`Ir para o ${label}`}
          title={label}
          sx={styleIcons.iconButtons}
        >
          <Icon sx={styleIcons.icons} />
        </IconButton>
      ))}
    </Box>
  );
};
